import { Groups, UserProduct } from '@interfaces/auth';

/**
 * Todo produto que a pessoa alcança, de QUALQUER balde, sem repetir.
 *
 * Existe separado do `getAllProducts` do contexto porque aquele não inclui `referrer` — e, uma vez
 * que a elegibilidade passou a ser permissão e não papel (§6.3), essa ausência vira exclusão:
 * indicador com grant explícito de um relatório nunca veria comunidade nenhuma no seletor, porque a
 * lista de candidatos não o continha para começo de conversa.
 *
 * Dedup por id, e não pelo objeto inteiro: os baldes se sobrepõem e a mesma comunidade vem com
 * `userRole` diferente em cada um — comparar o objeto deixaria as duas cópias passarem.
 */
export const produtosAlcancados = (groups: Groups): UserProduct[] => {
  const porId = new Map<UserProduct['id'], UserProduct>();

  for (const produto of [
    ...groups.owner,
    ...groups.coproducer,
    ...groups.affiliated,
    ...groups.referrer,
    ...groups.collaborator,
  ])
    if (!porId.has(produto.id)) porId.set(produto.id, produto);

  return [...porId.values()];
};

/**
 * Os produtos em que a pessoa tem VÍNCULO DE COMISSÃO — os quatro baldes de comissão, sem
 * colaboração.
 *
 * Existe separado de `produtosAlcancados` porque as duas perguntas são diferentes. "O que ela
 * alcança" é o conjunto de telas; "onde ela tem comissão" é o conjunto que uma consulta recortada
 * por `commission.user_id` cobre. Colaboração pura não gera linha de comissão, então incluí-la ali
 * exigiria permissão numa comunidade que não entra no resultado — e esconderia o que a pessoa
 * legitimamente poderia exportar.
 */
export const produtosComVinculoDeComissao = (groups: Groups): UserProduct[] => {
  const porId = new Map<UserProduct['id'], UserProduct>();

  for (const produto of [
    ...groups.owner,
    ...groups.coproducer,
    ...groups.affiliated,
    ...groups.referrer,
  ])
    if (!porId.has(produto.id)) porId.set(produto.id, produto);

  return [...porId.values()];
};
